import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { DashboardContext } from '../DashboardContext'

// עבור הקוביות2-4 לדשבורד.
const useTopCards = () => {
    const navigate = useNavigate()
    const { dashboardData } = useContext(DashboardContext)
    const { redo_assessments = 0, missing_details_test_takers = 0 } = dashboardData.attention || {}
    const { ready_reports = 0, active_test_takers = 0, semester_test_takers = 0 } = dashboardData.semester_summary || {}

    return React.useMemo(() => {
        // אותם יעדים כמו בקוביות הישנות (hooks/useCards.js)
        const goPerformAssessments = () => navigate(app.performAssessments)
        const goAssessments = () => navigate(app.assessments)
        const goTestTakers = () => navigate(app.testTakers)

        return [
            {
                id: "attention",
                className: "attention-card",
                title: "דורש תשומת לב",
                icon: "fa-regular fa-circle-exclamation",
                rows: [
                    { count: redo_assessments, text: "מבדקים לביצוע חוזר", info: true, button: { label: "לביצוע", action: goPerformAssessments } },
                   // תהיה פה רשימה של מה שדורש תשומת לב
                   // { count: missing_details_test_takers, text: "תלמידים חסרים פרטים", button: { label: "השלמה", action: goTestTakers } },
                ]
            },
            {
                id: "reports",
                title: "דוחות מוכנים לצפיה",
                icon: "fa-regular fa-check",
                value: ready_reports,
                button: { label: "לצפייה בדוחות", icon: "fa-regular fa-eye", action: goAssessments }
            },
            {
                id: "test-takers",
                title: "תלמידים פעילים",
                icon: "fa-regular fa-user",
                // תלמידים שהוקצתה להם סוללה מתוך כל תלמידי השנה 
                value: <>{active_test_takers} <span className='progress-of'>{`מתוך ${semester_test_takers}`}</span></>,
                button: { label: "לצפייה ברשימת התלמידים", icon: "fa-regular fa-eye", action: goTestTakers }
            }
        ]
    }, [navigate, redo_assessments, missing_details_test_takers, ready_reports, active_test_takers, semester_test_takers])
}

export default useTopCards
